import React, { FC } from 'react'

import { IconBroadbandOrWifiProps } from './IconBroadbandOrWifi.types'
import * as Styled from './styles/IconBroadbandOrWifi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBroadbandOrWifi: FC<IconBroadbandOrWifiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBroadbandOrWifiProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconBroadbandOrWifiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='m158.86 40.7-.1-.1a111.56 111.56 0 0 0-157.59.07 4 4 0 1 0 5.66 5.65 103.56 103.56 0 0 1 146.31 0 4 4 0 0 0 5.71-5.6z' />
        <path d='M23.17 63.68a4 4 0 1 0 5.66 5.65 72.86 72.86 0 0 1 102.94 0l2.83-2.83 2.78-2.87a80.85 80.85 0 0 0-114.21.05zM80.15 72a48.3 48.3 0 0 0-34.38 14.25 4 4 0 0 0 5.66 5.66A40.35 40.35 0 0 1 80.15 80a40.37 40.37 0 0 1 28.73 11.91l5.64-5.67A48.3 48.3 0 0 0 80.16 72z' />
        <circle cx='80' cy='115' r='8' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBroadbandOrWifi
